import React, { useEffect } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import useContactModal from "../../../hooks/useContactModal";
import ContactOwnerModal from "../../modals/ContactOwnerModal";

const PropertyDetails = ({ property }) => {
  const { isOpen, openModal, closeModal } = useContactModal();

  useEffect(() => {
    console.log("PropertyDetails received:", property);
  }, [property]);

  // Handle loading state
  if (!property) {
    return (
      <div className="text-center text-gray-500 py-8">
        Loading property details...
      </div>
    );
  }

  const prop = property.property || {};
  const floorPlan = prop.floorPlan || {};

  // Extract values safely
  const expectedPrice = floorPlan.expectedPrice || prop.price || null;
  const pricePerSqft = floorPlan.pricePerSqft || null;
  const brokerage = prop.brokerage || "N/A";
  const availabilityStatus = prop.availabilityStatus || "Not available";
  const ownership = prop.ownership || "Not specified";
  const floorNumber =
    floorPlan.floorNumber ||
    (prop.floors && prop.floors.propertyFloor) ||
    "Not specified";
  const address =
    property.location?.address?.formatted || "Address not available";

  const formatPrice = (value) => {
    if (!value || isNaN(value)) return "N/A";
    const num = Number(value);
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(2)} Lac`;
    return `₹${num.toLocaleString("en-IN")}`;
  };

  return (
    <div className="">
      <div className="mx-auto bg-white rounded-lg p-4 sm:p-6 md:p-8  w-full border">
        {/*  Header */}
        <h2 className="font-inter font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#222222] mb-3">
          More Details
        </h2>

        {/*  Property Details */}
        <div className="space-y-3 sm:space-y-4">
          {/* Price */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Price:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {expectedPrice ? formatPrice(expectedPrice) : "N/A"} /
              <span className="text-xs sm:text-sm text-[#666666] ml-2">
                {pricePerSqft
                  ? `₹${pricePerSqft.toLocaleString("en-IN")} per sqft`
                  : ""}
              </span>
            </div>
          </div>

          {/* Address */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Address:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {address}
            </div>
          </div>

          {/* Property In (Floor) */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Property In:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {floorNumber ? `Floor ${floorNumber}` : "Not specified"}
            </div>
          </div>

          {/* Brokerage */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Brokerage:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {brokerage}
            </div>
          </div>

          {/* Availability */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Availability:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] capitalize">
              {availabilityStatus.replaceAll("_", " ")}
            </div>
          </div>

          {/* Ownership */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-[#888888]">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Ownership:
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] capitalize">
              {ownership}
            </div>
          </div>
        </div>

        {/* contact button */}
        <button
          onClick={() => openModal()}
          className="mt-6 sm:mt-8 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-md transition-all duration-200 flex items-center gap-2 sm:gap-3 text-sm sm:text-base md:text-lg shadow-md hover:shadow-lg hover:scale-105"
        >
          <FaPhoneAlt className="text-sm sm:text-base md:text-lg" />
          Contact Owner
        </button>
      </div>
      <ContactOwnerModal
        isOpen={isOpen}
        onClose={closeModal}
        propertyData={property}
      />
    </div>
  );
};

export default PropertyDetails;
